export default __webpack_public_path__ + "static/media/google-workspace.4a905681.svg";